<template>
  <section>
    <!--工具条-->
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="filters">
          <el-form-item label="项目">
            <ProjectList @proSelected="proChange"></ProjectList>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="filters.time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.searchTab" placeholder="按标题搜索" :clearable="true"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" v-on:click="doSerch">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="showAddView">新增</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <!--列表-->
    <template>
      <el-table :data="data" highlight-current-row v-loading="loading">
        <el-table-column type="index" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column prop="rectifyName" label="标题" align="center">
        </el-table-column>
        <el-table-column prop="checkName" label="检查人" align="center">
        </el-table-column>
        <el-table-column prop="conName" label="责任施工员" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center" :formatter="formatStatus">
        </el-table-column>
        <el-table-column prop="updateTime" label="创建时间" align="center" :formatter="formatDate">
        </el-table-column>
        <el-table-column label="操作" width="251" align="center">
          <template slot-scope="scope">
            <el-button size="small" @click="openDetails(scope.$index, scope.row)">查看</el-button>
            <el-button size="small" @click="showEditView(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" :disabled="delBtn" size="small" @click="doDel(scope.$index, scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next" @current-change="searchPage" :page-size="limit" :total="total"
                       class="layout-right">
        </el-pagination>
      </el-col>
    </template>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
        <RectifyForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"
                     :type="GLOBAL.qualityType"></RectifyForm>
      </div>
    </el-dialog>

    <!-- 详情界面 -->
    <el-dialog title="" :visible.sync="detailsVisible" @close="dialogClose" :modal="false" :close-on-click-modal="false"
               class="details">
      <div class="mtitle">整改通知单</div>
      <table cellpadding="0" cellspacing="1">
        <tr>
          <td>整改单名称：{{formData.rectifyName}}</td>
          <td>分部工程：{{formData.sortProject.name}}</td>
        </tr>
        <tr>
          <td>问题类型：{{formData.questionType.name}}</td>
          <td>整改期限：{{formData.formatDate }}</td>
        </tr>
        <tr>
          <td>检查人：{{formData.checkName }}</td>
          <td>责任施工人员：{{formData.conName }}</td>
        </tr>
        <tr>
          <td>责任人：{{formData.rectifyDutyUserN }}</td>
          <td>整改状态：{{formData.status | formatDetailStatus}}</td>
        </tr>

        <tr>
          <td colspan="2">
            <div class="d_label">隐患表述</div>
            <div>
              {{formData.rectifyDesc}}
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="d_label">整改措施</div>
            <div>
              {{formData.rectifyMeasure}}
            </div>
          </td>
        </tr>
      </table>
      <div style="text-align: right;margin-top: 20px;">
        <el-button v-on:click="qrcodeView" type="success">查看二维码</el-button>
        <el-button type="primary" @click="exportDoc">导出</el-button>
      </div>
      <el-form :model="detailsForm" label-width="120px" :rules="detailsFormRules" ref="detailsForm">
        <div class="title"><i></i>相关图片</div>
        <div style="margin-bottom: 10px;">
          <img :src="GLOBAL.basePhotoPath+item" v-for="(item,index) in picList"
               @click="picOpen(GLOBAL.basePhotoPath+item)" class="pic1">
          <div style="clear: both"></div>
        </div>

        <div class="title"><i></i>回复意见</div>

        <ul v-for="item in detailMes" style="border-bottom: 1px  dashed #c0ccda;margin-bottom: 10px;">
          <li>
            <span style="margin-right: 10px;">
              <!--
					  <img src="https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png"/>-->
				    </span>{{item.employeeName}} &nbsp;&nbsp;&nbsp; {{item.formatDate}}
          </li>
          <li class="space">{{item.replyContent}}</li>
          <li>
            <img @click="picOpen(GLOBAL.basePhotoPath+ph)"
                 :src="GLOBAL.basePhotoPath+ph"
                 v-for="(ph,index) in item.replyPhoto==null?[]:item.replyPhoto.split(',')[0]!=''?item.replyPhoto.split(','):[]"
                 class="pic2">
            <div style="clear: both"></div>
          </li>
        </ul>
        <el-form-item prop="replyContent" label="回复内容">
          <el-input type="textarea" v-model="detailsForm.replyContent" ref="replycon"
                    :disabled="replyconDisabled"></el-input>
        </el-form-item>
        <el-form-item>
          <el-upload
            :action="this.GLOBAL.businessServerPath+'/imgupload'"
            :headers="this.GLOBAL.fileHeader"
            name="file"
            list-type="picture-card"
            :limit="3"
            :on-exceed="handleExceed"
            :on-remove="fileRemove"
            :on-success="fileSuccess"
            :file-list="fileList">
            <div class="pic_btn"><i class="el-icon-plus"></i></div>
          </el-upload>
        </el-form-item>
        <el-form-item prop="replyContent" label="签名确认">
          <div style=" height: 200px; width: 600px; border:1px dotted #c9c9c9; position: relative;">
            <canvas id="sign" width="600" height="200"></canvas>
            <div style="position: absolute; right: -87px; top: 5px;"><el-button type="success" size="small" :disabled="checkVisible" @click="checkSign">确认完成</el-button></div>
            <div style="position: absolute; right: -87px; top: 45px;"><el-button type="warning" size="small" @click="clearSign">更改清空</el-button></div>
          </div>
        </el-form-item>
      </el-form>


      <div slot="footer" class="dialog-footer">

        <span v-bind:class="{'use_dispaly':useFinish}"><el-button type="primary" @click.native="finishDetail" :disabled="btnVisible">整改完成</el-button></span>
        <span v-bind:class="{'use_dispaly':usePass}"><el-button type="success" @click.native="passDetail" :disabled="btnVisible">通过</el-button></span>
        <span v-bind:class="{'use_dispaly':usePass}"><el-button type="info" @click.native="unpassDetail" :disabled="btnVisible">不通过</el-button></span>
        <span v-bind:class="{'use_dispaly':useAgain}"><el-button type="danger" @click.native="againDetail" :disabled="btnVisible">重新整改</el-button></span>
        <span><el-button @click.native="detailsVisible = false">取消</el-button></span>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <!-- 二维码视图 -->
    <el-dialog :visible.sync="qrcodeVisible" title="查看二维码" :modal="false" :close-on-click-modal="false">
      <div class="q-title" style="text-align: center">{{formData.rectifyName}}-整改通知单</div>
      <div slot="footer">
        <div id="qrcode"></div>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import {rectifySearch, rectifyDel, rectifyDetail, rectifyConfirmMes, rectifydoc, rectifyConfirm,roleFuns,proSearch} from '../../api/api'

  import QRCode from 'qrcodejs2'
  import RectifyForm from "./RectifyForm";
  import ProjectList from "../command/ProjectList";

  export default {
    name: "SafeRectify",
    components: {ProjectList, RectifyForm},
    data() {
      return {
        data: [],
        page: 1,
        total: 0,
        limit: 15,
        filters: {proId:null,},
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        formVisible: false,
        detailsVisible: false,
        loading: false,
        option: 0,//0 添加 1 修改
        formData: {sortProject: {name: ''}, questionType: {name: ''}},
        delBtn: false,
        //以下是整改详情中对整改状态的控制属性
        fileList: [],
        detailsForm: {},
        detailsFormRules: {
          replyContent: [
            {required: true, message: '请输入回复内容', trigger: 'blur'}
          ]
        },
        detailMes: [],
        useFinish: true,
        usePass: true,
        useAgain: true,
        rectifyStatus: 0,//整改单状态
        replyconDisabled: true,//回复栏是否禁用
        picList: [],
        detailId: 0,
        qrcodeVisible: false,
        dialogVisible: false,
        dialogImageUrl: '',
        mesTotal: 0,
        imgList: [],
        proList:[],
        btnVisible:true,
        checkVisible:false,
      }
    },
    methods: {
      //查询数据
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.safeRectify, this.GLOBAL.option.select, this);
        this.loading = true;
        let rangTime = this.filters.time + "";
        let beginTime = null, endTime = null;
        if (rangTime) {
          beginTime = rangTime.split(",")[0];
          beginTime = new Date(beginTime);
          endTime = rangTime.split(",")[1];
          endTime = new Date(endTime);
        }

        let params = {
          page: this.page,
          limit: this.limit,
          beginTime: beginTime,
          endTime: endTime,
          searchTab: this.filters.searchTab,
          type: this.GLOBAL.qualityType,
          comId: this.GLOBAL.user.comId,
          proId: this.filters.proId == '' ? null : this.filters.proId
        };//请求参数

        rectifySearch(params, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data.result;
            this.total = result.data.total;
            this.loading = false;
          }
        });

      },
      //查询
      doSerch: function () {
        this.searchData();
      },
      //分页查询
      searchPage(val) {
        this.page = val
        this.searchData();
      },
      resetForm: function () {
        this.filters = {}
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.createTime, "yyyy-MM-dd hh:mm:ss");
      },
      formatStatus: function (row, column) {
        return row.status == 1 ? '一次整改中' : row.status == 2 ? '一次复查' : row.status == 3 ? '通过' : row.status == 4 ? '二次整改中' : row.status == 5 ? '二次复查' : row.status == 6 ? '未通过' : '通过';
      },
      //添加视图
      showAddView: function () {
        //标记权限验证 this.GLOBAL.roleTag.quality this.GLOBAL.roleTag.construction
        this.GLOBAL.checkRoleTag( this.GLOBAL.roleTag.quality,this);
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeRectify, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {rectifyDate: new Date(), sortProject: {name: ''}, questionType: {name: ''},proId:null,rectifyCheckUser:null,rectifyConUser:null,acceptUser:[]}
          this.formVisible = true;
        }
      },
      //编辑视图
      showEditView: function (index, row) {
        //标记权限验证 this.GLOBAL.roleTag.quality this.GLOBAL.roleTag.construction
        this.GLOBAL.checkRoleTag( this.GLOBAL.roleTag.quality,this);
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeRectify, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = row.id;
          rectifyDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeRectify, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
            rectifyDel({id: row.id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: "删除成功",
                  type: 'success'
                });
                this.searchData();
              }
            });
          }).catch(() => {
          });
        }
      },
      //查看详情
      openDetails: function (index, row) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.safeRectify, this.GLOBAL.option.message, this);
        if (res) {
          this.detailId = row.id;
          this.picList = [];
          this.detailsForm = {};
          rectifyDetail({id: row.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;

              if (this.formData.rectifyCheckUser == this.GLOBAL.user.id && (this.formData.status == 2)) {
                this.replyconDisabled = false;
                this.usePass = false;
                this.useAgain = false;

              } else if (this.formData.rectifyCheckUser == this.GLOBAL.user.id && this.formData.status == 5) {
                this.replyconDisabled = false;
                this.usePass = false;
                this.useAgain = true;

              } else if (this.formData.rectifyCheckUser == this.GLOBAL.user.id && this.formData.status == 6) {
                this.usePass = false;
              } else {
                this.replyconDisabled = true;
                this.usePass = true;
                this.useAgain = true;

              }
              if (this.formData.rectifyConUser == this.GLOBAL.user.id && (this.formData.status == 1 || this.formData.status == 4)) {
                this.replyconDisabled = false
                this.useFinish = false;
              } else {
                this.useFinish = true;
              }
              if (this.formData.rectifyDutyUserN != null && this.formData.rectifyDutyUserN != '') {
                this.rectifyDutyUserN = this.formData.rectifyDutyUserN.split(',');
              }
              if (result.data.rectifyPhoto != null && result.data.rectifyPhoto != '') {
                this.picList = result.data.rectifyPhoto.split(',');
              }
              this.signAreaInit();
              this.clearSign();
            }
          });
          rectifyConfirmMes({id: row.id, page: 1, limit: 10}, this.GLOBAL.header).then(result => {
            if (result.success) {

              this.detailMes = result.data.result;
              this.mesTotal = result.data.total;
            }
          });
          this.detailsVisible = true
        }
      },
      dialogClose: function () {
        this.fileList = [];
        this.searchData();
      },
      //分页查看回复
      pageConfirmMes: function (val) {
        this.page = val
        rectifyConfirmMes({id: this.detailId, page: this.page, limit: 2}, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.detailMes = result.data.result;
            this.mesTotal = result.data.total;
          }
        });
      },
      //回复
      reDetail: function () {
        this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
          this.$refs.detailsForm.validate((valid) => {
            if (valid) {
              this.detailsForm.userId = this.GLOBAL.user.id;
              this.detailsForm.reId = this.formData.id;
              this.detailsForm.parent = 0;
              this.detailsForm.replyPhoto = this.imgList.join(",");
              rectifyConfirm(this.detailsForm, this.GLOBAL.header).then(result => {
                if (result.success) {
                  this.$message({
                    message: "回复成功",
                    type: 'success'
                  });
                  this.detailMes.push({
                      employee: {employeeName: this.GLOBAL.user.employeeName},
                      formatDate: this.GLOBAL.formatTimeToStr(new Date(), "yyyy-MM-dd"),
                      replyContent: this.detailsForm.replyContent,
                      replyPhoto: this.detailsForm.replyPhoto
                    }
                  );
                  this.detailsVisible = false;
                  this.btnVisible = true;
                }
              });
            }
          });
        }).catch(() => {
        });

      },
      //整改不通过
      unpassDetail: function () {
        this.detailsForm.status = 6;
        this.formData.status = 6;
        this.reDetail();
      },
      //完成整改
      finishDetail: function () {
        if (this.formData.status == 4) {
          this.formData.status = 5;
          this.detailsForm.status = 5;
        } else {
          this.formData.status = 2;
          this.detailsForm.status = 2;
        }
        this.reDetail();
      },
      //通过整改
      passDetail: function () {
        this.detailsForm.status = 3;
        this.formData.status = 3;
        this.reDetail();
      },
      //重新整改
      againDetail: function () {
        this.detailsForm.status = 4;
        this.formData.status = 4;
        this.reDetail();
      },
      //导出doc
      exportDoc: function () {
        rectifydoc({reId: this.detailId,userId:this.GLOBAL.user.id}, this.GLOBAL.header).then(result => {
          this.downloadFile("/doc/rectify_" + this.detailId + ".docx");
        });
      },
      //删除上传图片
      fileRemove(file, fileList) {
        if (this.option == 0) {
          let n = this.imgList.indexOf(file.response.data);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
        } else {
          let index = file.url.lastIndexOf("/");
          file.url = file.url.substring(index - 9, file.url.length);
          let n = this.imgList.indexOf(file.url);
          let m = this.fileList.indexOf(file);
          if (n > -1) {
            this.imgList.splice(n, 1);
          }
          if (m > -1) {
            this.fileList.splice(m, 1);
          }
        }
      },
      //图片上传成功
      fileSuccess(response, file, fileList) {
        this.imgList.push(response.data);
      },
      //上传限制
      handleExceed: function (files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      //图片放大
      picOpen(url) {
        this.dialogImageUrl = url;
        this.dialogVisible = true;
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.updateTime, "yyyy-MM-dd hh:mm:ss");
      },

      qrcodeView() {
        this.qrcodeVisible = true
        this.qrcode.makeCode(this.GLOBAL.baseDomainUrl + '/rectifyview?id=' + this.detailId+'&userId='+this.GLOBAL.user.id);
      },
      showQEcodeView: function () {
        this.qrcode = new QRCode('qrcode', {
          width: 150, //图像宽度
          height: 150, //图像高度
          colorDark: '#000000', //前景色
          colorLight: '#ffffff', //背景色
          typeNumber: 4,
          correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
        })
      },
      proChange:function(proId){
        this.filters.proId = proId;
        this.doSerch();
      },
      downloadFile: function (file) {
        if (file != null && file != '') {
          let url = this.GLOBAL.baseDocumentPath + file;    // 获取图片地址
          let a = document.createElement('a');          // 创建一个a节点插入的document
          let event = new MouseEvent('click')       // 模拟鼠标click点击事件
          a.download = 'rectify'                  // 设置a节点的download属性值
          a.href = url;                                 // 将图片的src赋值给a节点的href
          a.dispatchEvent(event)                        // 触发鼠标点击事件
        }
      },
      //初始化签名区
      signAreaInit:function(){
        canvas = document.getElementById('sign');
        if (canvas.getContext) {
          context = canvas.getContext('2d');
        }
        let _this = this;
        let initUrl = apiUrl + 'InitialDevice?id=2&width=600&height=200';
        let getInkUrl = apiUrl + 'GetInks';
        $.ajax({
          url: initUrl,
          type: 'GET',
          cache: false
        }).done(function (response) {
          if (response === true) {
            let isPolling = true;
            getInk(isPolling,getInkUrl);
          } else {
            alert('No device!');
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          alert('Connection fail(' + jqXHR.status + ')!');
        });
      },
      clearSign:function(){
        let clrInkUrl = apiUrl + 'Clear';
        $.ajax({
          url: clrInkUrl,
          type: 'GET',
          cache: false,
          success: function success() {
            let canvas = document.getElementById('sign');
            if(context!=null && context!='undefined' && canvas!=null && canvas!='undefined')
            context.clearRect(0, 0, canvas.width, canvas.height);
          }
        });
      },
      checkSign:function(){
        let oldPic = 'data:image/png;base64,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';
        let pic = document.getElementById("sign").toDataURL("image/png");
        if(pic==oldPic){
          this.$message({
            message: "请完成签名",
            type: 'warning'
          });
        }else{
          pic = pic.replace(/^data:image\/(png|jpg);base64,/, "");
          let _this = this;
          $.ajax({
            type: 'POST',
            url: this.GLOBAL.businessServerPath+'/saveimage',
            data: '{ "imageData" : "' + pic + '" ,"fix":'+this.GLOBAL.user.id+'}',
            headers: {token: this.GLOBAL.user.token, 'Content-Type': 'application/json;charset=utf8'},
            dataType: 'json',
            success: function (result) {
              if(result.success){
                _this.detailsForm.userCode = result.data;
                _this.btnVisible = false;
                _this.$message({
                  message: "完成签名",
                  type: 'success'
                });
              }
            }
          });
        }

      },
      mesClose:function(){
        clearTimeout(timeId);
        this.clearSign();
        this.btnVisible = true;
        this.useAccpt = true;
      },
    },
    filters: {
      formatDetailStatus: function (status) {
        return status == 1 ? '一次整改中' : status == 2 ? '一次复查' : status == 3 ? '通过' : status == 4 ? '二次整改中' : status == 5 ? '二次复查' : status == 6 ? '未通过' : '通过';
      }
    },
    mounted() {
      this.showQEcodeView();

    },
    destroyed() {
      clearTimeout(timeId);
      this.clearSign();
      this.btnVisible = true;
      this.useAccpt = true;
    }
  }
  //==========================================
  function getInk(isPolling,getInkUrl){
    (function poll() {
      timeId = setTimeout(function () {
        clearTimeout(timeId);
        if (isPolling) {
          $.ajax({
            url: getInkUrl,
            type: 'GET',
            cache: false
          }).done(function (data) {
            let dataInfos = JSON.parse(data);
            dataInfos.forEach(function (value) {
              if (value.EventType === 0) {
                drawImage(value.Image);
              }
            });
          }).always(function () {
            if (isPolling) {
              poll();
            } else {}
          });
        }
      }, 50);
    })();
  }
  let timeId;
  let canvas;
  let context;
  let apiUrl = "http://127.0.0.1:8089/PPSignSDK/"
  function drawImage(base64) {
    let dataUrl = 'data:image/png;base64,';
    dataUrl = dataUrl + base64;
    // 在image中載入圖檔，再畫到canvas呈現
    let img = new Image();
    img.addEventListener('load', function () {
      context.drawImage(this, 0, 0, canvas.width, canvas.height);
    }, false);
    img.src = dataUrl;
  };
  // Generate random number
  function generateString(length) {
    let text = "";
    let possible = "0123456789";

    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }return text;
  }
  //==========================================
</script>

<style scoped>
  .details .mtitle {
    position: relative;
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .details .d_label {
    height: 30px;
    line-height: 30px;
  }

  .details table {
    width: 100%;
    background: #d0d0d0
  }

  .details table tr {
    background: #f1f1f1;
    height: 60px;
    text-indent: 2em
  }

  .details ul {
    margin: 0;
    padding: 0;
  }

  .details ul li {

    line-height: 60px;
    list-style: none
  }

  .details img {

    margin: 10px 0px 10px 10px;
    float: left;
    cursor: pointer;
  }

  .pic1 {
    max-width: 150px;
    border-radius: 20px;
    min-height: 150px;
  }

  .pic2 {
    border-radius: 10px;
    max-width: 50px;
    min-height: 50px;
  }

  .details .space {
    text-indent: 2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/rectify/QualityRectify.vue